// src/api/index.js
import service from "../auth/FetchInterceptor";
import { insuranceAPI, lossAPI, lmsAPI, collateralAPI } from "./axiosInstances";

export const insuranceClient = service(insuranceAPI);
export const lossClient = service(lossAPI);
export const lmsClient = service(lmsAPI);
export const collateralClient = service(collateralAPI);